var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('material-snackbar',_vm._b({attrs:{"type":_vm.snackbar.type,"timeout":"5000"},model:{value:(_vm.snackbar.show),callback:function ($$v) {_vm.$set(_vm.snackbar, "show", $$v)},expression:"snackbar.show"}},'material-snackbar',{
      bottom: true,
      right: true,
      color: _vm.snackbar.color,
    },false),[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }